export const barChartStyle = {
    backgroundColor: '#C75FF5',
    borderColor: '#C75FF5',
    borderWidth: 1,
    barThickness: 20,
    borderRadius: 0,
    borderSkipped: false
}

export const targetBarChartScatterStyle = {
    type: "scatter",
    pointBackgroundColor: "#F6680B",
    pointBorderColor: "#F6680B",
    fill: true,
    pointRadius: 13,
    pointHoverRadius: 14,
    label: "" 
}

export const targetBarChartBarStyle = {
    type: "bar",
    borderColor: "#C75FF5",
    backgroundColor: "#C75FF5",
    fill: true,
    borderWidth: 1,
    barThickness: 20,
    borderRadius: 0,
    label: "" ,
    borderSkipped: false
}